package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.react.{StateAttribute, StateContextBase}
import org.scalajs.dom.console

case class ErrorState
(
	errorStrings: StateAttribute[Vector[String]]
)
{
	def addError(error: String): Unit = {
		console.log(message = s"ErrorState.addError: $error")
		errorStrings.setValue(errorStrings.value :+ error)
	}

	def removeError(index: Int): Unit = {
		if ((index >= 0) && (index < errorStrings.value.size)) {
			errorStrings.setValue(errorStrings.value.patch(index, Nil, 1))
		}
	}
}

object ErrorState extends StateContextBase[ErrorState, Vector[String]] {
	override protected def defaultStateValue() = Vector()

	override protected def makeState(a: StateAttribute[Vector[String]]) = ErrorState(a)
}